import { Component, Inject, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'group-lesson',
  templateUrl: './group-lesson.component.html',
  styleUrls: [
    './group-lesson.component.css',
    '../../../../app.component.css'
  ]
})
export class GroupLessonComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: {InstructorList: {}, lesson_types: string[]}) { }

  ngOnInit(): void {
  }

  onSubmit(form: NgForm) {
    LoggerService.log(form.value);
  }

}
